import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { TenantInfo } from '../types';
import {
  Container,
  Paper,
  Typography,
  Box,
  List,
  ListItem,
  ListItemText,
  Chip,
  Alert,
} from '@mui/material';
import { Business } from '@mui/icons-material';

const SelecionarTenant: React.FC = () => {
  const { user, switchTenant, hasRole } = useAuth();
  const navigate = useNavigate();
  const [erro, setErro] = React.useState('');
  const [selecionando, setSelecionando] = React.useState(false);

  const tenants: TenantInfo[] = user?.tenants || [];

  React.useEffect(() => {
    if (tenants.length === 1) {
      handleSelect(tenants[0]);
    }
  }, []);

  const handleSelect = async (tenant: TenantInfo) => {
    setErro('');
    setSelecionando(true);
    try {
      await switchTenant(tenant.id);
      if (hasRole('MOTORISTA')) navigate('/solicitacoes', { replace: true });
      else navigate('/dashboard', { replace: true });
    } catch (error: any) {
      setErro(error?.response?.data?.message || 'Erro ao selecionar organização');
    } finally {
      setSelecionando(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    window.location.href = '/login';
  };

  return (
    <Container disableGutters maxWidth="sm">
      <Box sx={{ mt: 10, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Business sx={{ fontSize: 48, color: 'primary.main', mb: 2 }} />
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Selecione a Organização
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          Você está vinculado a mais de uma organização. Escolha qual deseja acessar.
        </Typography>

        {erro && <Alert severity="error" sx={{ mb: 2, width: '100%' }}>{erro}</Alert>}

        <Paper elevation={2} sx={{ width: '100%' }}>
          <List disablePadding>
            {tenants.map((tenant, index) => (
              <ListItem
                key={tenant.id}
                onClick={() => !selecionando && handleSelect(tenant)}
                disabled={selecionando}
                sx={{
                  cursor: 'pointer',
                  borderBottom: index < tenants.length - 1 ? '1px solid' : 'none',
                  borderColor: 'divider',
                  '&:hover': { bgcolor: 'action.hover' },
                }}
              >
                <ListItemText
                  primary={tenant.nome}
                  secondary={tenant.tipo}
                  secondaryTypographyProps={{ variant: 'caption' as any }}
                />
                {tenant.padrao && (
                  <Chip label="Padrão" size="small" color="primary" variant="outlined" />
                )}
              </ListItem>
            ))}
          </List>
        </Paper>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mt: 3, cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
          onClick={handleLogout}
        >
          Fazer login com outra conta
        </Typography>
      </Box>
    </Container>
  );
};

export default SelecionarTenant;
